import { SUBSCRIPTION_DETAILS } from '@client/actions';
import { Action } from '@client/lib/action';

export class SubscriptionDetailsInitAction implements Action {
	readonly type = SUBSCRIPTION_DETAILS.INIT;
	constructor(public payload?: null, public correlationId?: number) {}
}

export class SubscriptionDetailsDestroyAction implements Action {
	readonly type = SUBSCRIPTION_DETAILS.DESTROY;
	constructor(public payload?: null, public correlationId?: number) {}
}

export class SubscriptionDetailsClickEditAction implements Action {
	readonly type = SUBSCRIPTION_DETAILS.CLICK_EDIT;
	constructor(public payload?: null, public correlationId?: number) {}
}
